import { render, staticRenderFns } from "./productFLowSpeedRules.vue?vue&type=template&id=c3a854ac&scoped=true&"
import script from "./productFLowSpeedRules.vue?vue&type=script&lang=js&"
export * from "./productFLowSpeedRules.vue?vue&type=script&lang=js&"
import style0 from "./productFLowSpeedRules.vue?vue&type=style&index=0&id=c3a854ac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a854ac",
  null
  
)

export default component.exports